import React, { useEffect, useCallback } from 'react';
import LoaderSpinner from '../common/Loader';
import { Box, Typography, Paper, TextField, InputAdornment, Radio } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useNavigate } from 'react-router-dom';
import { getAllTemplates, deleteTemplate } from '../../store/actions/auth';
import { toast } from 'react-toastify';
import AlertDialogModal from '../common/AlertDialog';
import edit_icon from "../../assets/edit_icon.svg";
import emailIcon from "../../assets/emailIcon.svg";
import { deleteIconRed } from '../../constant';
const useStyles = makeStyles((theme) => ({
    templateItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2, 3),
        marginBottom: theme.spacing(1.5),
        border: '1px solid #e0e0e0',
        borderRadius: 4,
        cursor: 'pointer',
        boxShadow: 'none',
        transition: 'border-color 0.2s, box-shadow 0.2s, background-color 0.2s',
        '&:hover': {
            borderColor: '#3f51b5',
            boxShadow: '0 2px 8px rgba(63, 81, 181, 0.15)',
            backgroundColor: '#f5f7ff',
        },
    },
    templateItemSelected: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2, 3),
        marginBottom: theme.spacing(1.5),
        border: '2px solid #3f51b5',
        borderRadius: 4,
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(63, 81, 181, 0.15)',
        backgroundColor: '#f5f7ff',
    },
    templateName: {
        fontSize: '1rem',
        color: '#212121',
    },
    iconBtn: {
        border: 0,
        background: 'transparent',
        padding: 0,
        marginLeft: 5,
        cursor: 'pointer',
        '&:focus-visible': {
            outline: '2px solid #3f51b5',
            outlineOffset: 2,
            borderRadius: 2,
        },
    },
}));


const EmailTemplates = () => {
    const navigate = useNavigate();
    const classes = useStyles();
    const [showLoader, setShowLoader] = React.useState(false);
    const [templates, setTemplates] = React.useState([]);
    const [searchQuery, setSearchQuery] = React.useState('');
    const [deleteId, setDeleteId] = React.useState(null);
    const [selectedTemplateId, setSelectedTemplateId] = React.useState(null);

    const fetchTemplates = useCallback(async () => {
        setShowLoader(true);
        try {
            const response = await getAllTemplates();
            setTemplates(response.data.EntityList || []);
        } catch (error) {
            toast.error('An error occurred while fetching templates.');
        } finally {
            setShowLoader(false);
        }
    }, []);

    useEffect(() => {
        fetchTemplates();
    }, [fetchTemplates]);

    const handleNewTemplate = () => {
        navigate('/email-templates/0', { state: { isNew: true } });
    };

    const goComposeEmail = () => {
        const selectedTemplate = templates.find(t => t.id === selectedTemplateId);
        navigate('/email-templates/compose-email', {
            state: selectedTemplate ? { selectedTemplate } : undefined,
        });
    };

    const handleTemplateSelect = (templateId) => {
        setSelectedTemplateId(prev => prev === templateId ? null : templateId);
    };

    const handleDelete = (id) => {
        setDeleteId(id);
    };

    const confirmDelete = async () => {
        const id = deleteId;
        setDeleteId(null);
        setShowLoader(true);
        try {
            const response = await deleteTemplate(id);
            if (response?.data?.Status === 200) {
                toast.success('Template deleted successfully!');
                fetchTemplates();
            } else {
                toast.error('Template not found. It may have already been deleted.');
            }
        } catch {
            toast.error('An error occurred while deleting the template.');
        } finally {
            setShowLoader(false);
        }
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    <span>
                        Email Templates
                        <div className='infoPermission'>Manage the email templates used for various notifications and communications.</div>
                    </span>
                    <div className="top_right_button_container">
                        <div className="top_right_button_container">
                            <button className="btn cus-seconday-bg-btn btn mr-2" onClick={goComposeEmail}>
                                Compose
                            </button>
                            <button className="btn cus-seconday-bg-btn btn  mr-2" onClick={handleNewTemplate}>
                                Create New Template
                            </button>
                            <button className="btn cus-primary-transparent-btn bckbtn" onClick={() => navigate('/setting')}>
                                Back
                            </button>
                        </div>
                    </div>
                </div>
                {showLoader && <LoaderSpinner />}
                <div className="cus-page-content-sec">
                    <div className='content-container'>
                        <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Search templates..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{ marginBottom: 16, width: 320 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search style={{ color: '#999' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Box>
                            {templates
                                .filter((t) => t.name?.toLowerCase().includes(searchQuery.toLowerCase()))
                                .map((template) => (
                                <Paper
                                    key={template.id}
                                    className={selectedTemplateId === template.id ? classes.templateItemSelected : classes.templateItem}
                                    onClick={() => handleTemplateSelect(template.id)}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <Radio
                                            checked={selectedTemplateId === template.id}
                                            color="primary"
                                            size="small"
                                            onClick={(e) => { e.stopPropagation(); handleTemplateSelect(template.id); }}
                                            inputProps={{ 'aria-label': `Select ${template.name}` }}
                                        />
                                        <div>
                                            <Typography className={classes.templateName}>
                                                {template.name}
                                                {template.attachmentCount > 0 && (
                                                    <span
                                                        title={`${template.attachmentCount} attachment(s)`}
                                                        aria-label={`${template.attachmentCount} attachments`}
                                                        style={{ marginLeft: 8, fontSize: 12, color: '#777' }}
                                                    >
                                                        &#128206; {template.attachmentCount}
                                                    </span>
                                                )}
                                            </Typography>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', gap: 4 }}>
                                        <button
                                            type="button"
                                            className={`editIcon-btn mr-15 ${classes.iconBtn}`}
                                            disabled={showLoader}
                                            aria-label="Send email with template"
                                            data-testid="sendEmailIcon"
                                            title="Send email with this template"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate('/email-templates/compose-email', {
                                                    state: { selectedTemplate: template, sendOnly: true },
                                                });
                                            }}
                                        >
                                            <img src={emailIcon} alt="" className="editIcon" />
                                        </button>
                                        <button
                                            type="button"
                                            className="editIcon-btn mr-15 sortBtn"
                                            disabled={showLoader}
                                            aria-label="Edit template"
                                            data-testid="editIcon"
                                            onClick={(e) => { e.stopPropagation(); navigate(`/email-templates/${template.id}`); }}
                                        >
                                            <img src={edit_icon} alt="" className="editIcon" />
                                        </button>
                                        <button
                                            type="button"
                                            className="trash-btn sortBtn"
                                            disabled={showLoader || template.isDefault}
                                            aria-label="Delete template"
                                            data-testid="deleteIcon"
                                            style={{ visibility: template.isDefault ? 'hidden' : 'visible' }}
                                            onClick={(e) => { e.stopPropagation(); handleDelete(template.id); }}
                                        >
                                            {deleteIconRed()}
                                        </button>
                                    </div>
                                </Paper>
                            ))}
                            {templates.length === 0 && !showLoader && (
                                <Typography variant="body1" color="textSecondary" align="center">
                                    No email templates found. Click &quot;Create New Template&quot; to get started.
                                </Typography>
                            )}
                            {templates.length > 0 && !showLoader && !templates.some((t) => t.name?.toLowerCase().includes(searchQuery.toLowerCase())) && (
                                <Typography variant="body1" color="textSecondary" align="center">
                                    No templates match your search.
                                </Typography>
                            )}
                        </Box>
                    </div>
                </div>
            </div>
            <AlertDialogModal
                modalShow={!!deleteId}
                handleCancelDeleteAlert={() => setDeleteId(null)}
                handleYesDeleteAlert={confirmDelete}
                headingText="Delete Template"
                messageText="Are you sure you want to delete this template? This action cannot be undone."
            />
        </main>
    );
}

export default EmailTemplates;